export const defaultStyles = {
  textAlign: "left",
  fontWeight: "normal",
  textDecoration: "none",
  fontStyle: "normal",
};

export const defaultTitle = "New table"
